import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ActionButton } from '@bingads-webui-react/fabric-control';

import { getFooterButtonStyles } from './styles/footer-button';

export const FooterButton = ({
  index,
  selectedImage,
  footerButtonProps,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getFooterButtonStyles({ styleOverrides: styleOverrides.footerButton }));

  if (footerButtonProps) {
    const {
      onClick,
      onRenderIcon,
      buttonText,
      buttonClassName,
    } = footerButtonProps;

    return (
      <ActionButton
        className={classnames(buttonClassName, classes.footerButton)}
        onRenderIcon={onRenderIcon}
        onClick={() => onClick({ index, selectedImage })}
      >
        { buttonText }
      </ActionButton>
    );
  }

  return null;
};

FooterButton.propTypes = {
  index: PropTypes.number.isRequired,
  selectedImage: PropTypes.shape({}).isRequired,
  footerButtonProps: PropTypes.shape({
    onClick: PropTypes.func,
    onRenderIcon: PropTypes.func,
    buttonText: PropTypes.string,
    buttonClassName: PropTypes.string,
  }),
  styleOverrides: PropTypes.shape({
    footerButton: PropTypes.shape({}),
  }),
};

FooterButton.defaultProps = {
  footerButtonProps: null,
  styleOverrides: {},
};
